import { Base } from "./Base.model";

export class ThanhVienPhanQuyenChucNang extends Base{

DanhMucChucNangID?: number;
DanhMucThanhVienID?: number;
StateAgencyID?: number;
AgencyDepartmentID?: number;
DanhMucChucDanhID?: number;
AgencyDepartmentName?: string;
}


